<template>
  <b-row>
    <b-col cols="3">
      <cloud-foto
        :url="apiUnitPath + '/foto'"
        :uploadfolder="cloudUploadPath"
        title="Thumbnail"
        public_id="thumbnail"
      />
      <cloud-foto
        :url="apiUnitPath + '/gebouwfoto'"
        :uploadfolder="cloudUploadPath"
        title="Gebouwfoto"
        public_id="gebouwfoto"
      />
    </b-col>
    <b-col>
      <b-tabs>
        <b-tab>
          <template slot="title">
            <i class="fa fa-file" />
            rapportage ({{ fotos.length }} foto's)
          </template>

          <b-button 
            :disabled="isBusy" 
            variant="success" 
            class="my-2" 
            @click="saveFotos"
          >
            <i 
              v-if="!isBusy" 
              class="fa fa-save mx-1"
            />
            <b-spinner
              v-else
              :small="true"
              size="sm"
              class="mx-1"
              role="status"
              variant="secondary"
            />Opslaan rapportage foto's
          </b-button>

          <b-row>
            <b-col 
              v-for="(foto,index) in fotos" 
              :key="index" 
              cols="6"
            >
              <b-card 
                no-body 
                class="overflow-hidden" 
                style="max-height:300px;"
              >
                <b-row no-gutters>
                  <b-col 
                    md="6" 
                    class="d-flex align-items-center"
                  >
                    <b-card-img 
                      :src="foto.secure_url" 
                      class="rounded-0 img-fluid card-img-top"
                    />
                  </b-col>
                  <b-col md="6">
                    <b-card-body :title="(index+1) + ' ' + (foto.titel || 'Geen')">
                      <b-card-text>
                        <b-input 
                          v-model="foto.titel" 
                          class="my-2" 
                          placeholder="Omschrijving"
                        />

                        <b-button-group>
                          <b-button 
                            :disabled="index == 0" 
                            @click="moveFoto(index,Number(index-1))"
                          >
                            <i class="fa fa-arrow-left" />
                          </b-button>
                          <b-button
                            :disabled="index == (fotos.length-1)"
                            @click="moveFoto(index,Number(index+1))"
                          >
                            <i class="fa fa-arrow-right" />
                          </b-button>
                        </b-button-group>

                        <b-button
                          size="sm"
                          class="mx-2"
                          variant="danger"
                          @click="fotos.splice(index, 1);"
                        >
                          <i class="fa fa-trash" />
                        </b-button>
                        <b-form-text>
                          {{ foto.created_at | formatDateTime }}
                          <small>{{ foto.public_id.substring(0,45)+".." }}</small>
                        </b-form-text>
                      </b-card-text>
                    </b-card-body>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab>
          <template slot="title">
            <i class="fa fa-folder" /> elementen
          </template>
          <media-grid
            :url="apiCloudResources + '/img'"
            :uploadfolder="cloudUploadPath + '/img'"
            @foto-select="fotos.push($event)"
          />
        </b-tab>
        <b-tab>
          <template slot="title">
            <i class="fa fa-folder" /> gebreken
          </template>
          <media-grid
            :url="apiCloudResources + '/gebreken'"
            :uploadfolder="cloudUploadPath + '/gebreken'"
            @foto-select="fotos.push($event)"
          />
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>
<script>
import { mediaMixin } from "@/mixins/mediaMixin";
import { serviceMixin } from "@/mixins/serviceMixin";
import MediaGrid from "@/components/MediaGrid";
import CloudFoto from "@/components/CloudFoto";

export default {
  name: "Fotoboek",
  components: {
    MediaGrid,
    CloudFoto
  },
  mixins: [mediaMixin, serviceMixin],
  props: {"unit":{type:Object,required:true}},
  data() {
    return {
      fotos: [],
      isBusy: false
    };
  },
  computed: {
    // admin-api
    apiUnitPath: function() {
      return "/unit/" + this.$props.unit.Id;
    },
    // via de admin-api de resources
    apiCloudResources: function() {
      return "/media/cloudinary/" + this.$props.unit.Id;
    },
    // direct upload path
    cloudUploadPath: function() {
      return "/data/" + this.$props.unit.Id;
    },
    url: function() {
      return this.apiUnitPath + "/fotos";
    }
  },
  watch: {
    unit: {
      handler: function () {
        this.getMedia();
      },
      deep: true,
    },
  },
  mounted() {
    this.getMedia();
  },
  methods: {
    addFoto(foto) {
      console.dir(foto);
    },
    moveFoto(oldPos, newPos) {
      if (newPos >= this.fotos.length) {
        var k = newPos - this.fotos.length + 1;
        while (k--) {
          this.fotos.push(undefined);
        }
      }
      this.fotos.splice(newPos, 0, this.fotos.splice(oldPos, 1)[0]);
    },
    saveFotos() {
      var vm = this;
      this.isBusy = true;
      this.post(
          this.apiUnitPath + "/fotos",
          { fotos: this.fotos },
          
        )
        .then(function(response) {
          console.dir(response.data);
          vm.fotos = response.data.fotos;
        })
        .catch(function(error) {
          console.log(error);
        })
        .then(function() {
          vm.isBusy = false;
        });
    }
  },
};
</script>
<style scoped>
.card-img-top {
  width: 100%;
  height: 15vw;
  object-fit: cover;
}
</style>